<script>
    import _ from 'lodash';
    import {Link, navigate} from 'svelte-routing';
    import {network, store} from '../stores.js';
    import {list} from '../config.js';
    import {findLinkByParts, send_order_mail} from '../helpers.js';
    import {send_nomdoc} from '../events.js';
    import storage from '../storage.js';

    const user = store('credential', 'getAuth');
    const cart = store('cart-items', '', '[]');
    const cart_data = store('cart-data', '', '{"id": 0, "nomDoc": -1, "nomDocStr": "", "fio": "", "tel": "", "email": "", "address": "", "comment": "", "note": ""}');

    let order_num = '';

    const handlerEdit = (id) => {
        if (id >= 0) {
            let title = $cart.find((el) => +el.idTovar === id).title;
            let link = findLinkByParts(list, title);

            document.querySelector('[data-bs-target="#cartPanel"]').click();

            storage.setItem('calc-edit', id);
            navigate('/loading');
            setTimeout(() => navigate('/calc/' + link, {replace: true}), 50);
        }
    };
    const handlerRemove = (index) => {
        if (index >= 0) {
            $cart = $cart.filter((el, i) => i !== index);
            cart.save($cart);
        }
    };

    const handlerSaveCardData = () => {
        if (typeof $cart_data === 'object') {
            cart_data.save($cart_data);
        }
    }

    let price_type = 'rozn';
    let is_disabled = false;
    let is_error = false;

    const handlerSend = async (create_new = true) => {
        is_disabled = true;

        let xml = '<Attributes>';

        _.forEach($cart, (tovar) => {
            xml += '<ProductAttribute idTovar="' + tovar.idTovar + '">';
            xml += '<ProductAttributeValue>';
            xml += '<kolvo>' + tovar.quantity + '</kolvo>';
            xml += '<summa>' + tovar.price[price_type] * tovar.quantity + '</summa>';
            xml += '<summaRozn>' + tovar.price.rozn  + '</summaRozn>';
            xml += '<summaDil>' + (isNaN(tovar.price.opt) ? 0 : tovar.price.opt) + '</summaDil>';
            xml += '<sebestoim>' + (isNaN(tovar.price.sebest) ? 0 : tovar.price.sebest) +'</sebestoim>';
            xml += '</ProductAttributeValue>';
            xml += '</ProductAttribute>';
        });

        xml += '</Attributes>';

        if ($cart_data.tel) {
            let result = await network.get(create_new ? 'viborkaAddApp2' : 'viborkaUpdApp', {
                tovarxml: xml,
                nameKontakt: $cart_data.fio ?? '',
                adresKontakt: $cart_data.address ?? '',
                telefonKontakt: $cart_data.tel ?? '',
                emailKontakt: $cart_data.email ?? '',
                komment: $cart_data.comment ?? '',
                dopInfo: $cart_data.note ?? '',
                tipCen: price_type,
                idKontakt: $cart_data.id ?? 0,
                nomDoc: $cart_data.nomDoc ?? -1,
                nomDocStr: $cart_data.nomDocStr ?? '',
                idSklad: +$user.idSklad,
                idKontr: +$user.idkontr,
                userId: +$user.id,
            });

            if (result && result.nomDoc) {
                order_num = result.nomDoc;

                // отправляем номер документа
                send_nomdoc(order_num, $cart);

                // шлем почту
                let mail = {
                    name: $cart_data.fio ?? '',
                    tel: $cart_data.tel ?? '',
                    email: $cart_data.email ?? null,
                    address: $cart_data.address ?? null,
                    admin: $user.email ?? null
                };
                await network.post('mail', send_order_mail(order_num, mail, $cart));

                let popup = new bootstrap.Modal(document.getElementById('order-send'));
                    popup.show();

                cart.remove();
                cart_data.remove();

                // тригер отправки события
                setTimeout(() => window.top.postMessage('send_order::' + order_num, '*'), 1500);
                setTimeout(() => {
                    popup.hide();
                    navigate('/dashboard');
                }, 1000 * 60);

                return is_disabled = false;
            }
        }

        is_error = true;

        setTimeout(()=> is_disabled = is_error = false, 1000 * 5)
    }

    const handlerClear = () => {
        cart.save([]);
        cart_data.save({});
        storage.removeItem('params');
    };
</script>

<!-- App OffCanvas -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="cartPanel">
    <div class="offcanvas-header">
        <h5 id="offcanvas-title" style="font-size: 1.25rem; margin: 0;">Корзина</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        {#if $cart.length}
            <ul class="nav nav-tabs capsuled" id="order-tabs" role="tablist">
                <li class="nav-item col-6" role="presentation">
                    <button class="nav-link w-100 active" id="order-tab" data-bs-toggle="tab" data-bs-target="#order" type="button" role="tab" aria-controls="order" aria-selected="true">
                        <i class="fas fa-shopping-cart pe-1"></i>
                        Заказ
                    </button>
                </li>
                <li class="nav-item col-6" role="presentation">
                    <button class="nav-link w-100" id="client-tab" data-bs-toggle="tab" data-bs-target="#client" type="button" role="tab" aria-controls="client" aria-selected="false">
                        <i class="far fa-user-circle pe-1"></i>
                        Контакты
                    </button>
                </li>
            </ul>

            <div class="tab-content" id="order-tabs-content">
                <div class="tab-pane fade show active" id="order" role="tabpanel" aria-labelledby="order-tab">
                    {#if
                        $user
                        && ($user.tip.toLowerCase().includes('администратор') || $user && $user.tip.toLowerCase().includes('менеджер'))
                        && !$cart_data.nomDocStr
                    }
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <select class="form-control form-select" bind:value={price_type}>
                                            <option value="rozn" selected>Розничная цена</option>
                                            <option value="opt">Дилерская цена</option>

                                            {#if $user && $user.tip.toLowerCase().includes('администратор')}
                                                <option value="sebest">Закупочная цена</option>
                                            {/if}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}

                    <div class="row my-1">
                        <div class="col-6"><b>Сумма:</b></div>
                        <div class="col-6" style="text-align: right">{_.sumBy($cart, (o) => +o.price[price_type] * +o.quantity).toLocaleString()}₽</div>
                    </div>

                    {#each $cart as tovar, index}
                        <div class="row mb-2" data-id="{tovar.idTovar}" title="{tovar.title}">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12">
                                                <b>{tovar.name}</b><br>
                                                <p class="text-muted" style="font-size: 11px; line-height: 1.0;">{@html tovar.subname.replaceAll('; ', '<br>')}</p>
                                            </div>
                                            <div class="col-12 text-muted" style="text-align: right">
                                                {#if tovar.quantity > 1}
                                                    {(+tovar.price[price_type]).toLocaleString()}₽
                                                    &times;
                                                    {tovar.quantity}шт
                                                    =
                                                {/if}
                                                {(+tovar.price[price_type] * +tovar.quantity).toLocaleString()}₽
                                            </div>
                                        </div>
                                    </div>

                                    {#if
                                        (
                                            APP_TYPE === 'profile-doors' &&
                                            !tovar.type.toLowerCase().includes('монтаж')
                                        ) || (
                                            !tovar.type.toLowerCase().includes('доставка') &&
                                            !tovar.type.toLowerCase().includes('монтаж') &&
                                            !tovar.type.toLowerCase().includes('услуги')
                                        )
                                    }
                                        <div class="col-6">
                                            <button class="btn btn-secondary btn-sm w-100" on:click={() => handlerEdit(tovar.idTovar)}>
                                                <i class="far fa-edit pe-1"></i>
                                                Изменить
                                            </button>
                                        </div>
                                    {:else}
                                        <div class="col-6"></div>
                                    {/if}
                                    <div class="col-6">
                                        <button class="btn btn-danger btn-sm w-100" on:click={() => handlerRemove(index)}>
                                            <i class="fas fa-trash-alt pe-1"></i>
                                            Удалить
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>

                <div class="tab-pane fade" id="client" role="tabpanel" aria-labelledby="client-tab">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">ФИО <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" bind:value={$cart_data.fio} on:change={handlerSaveCardData}>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Телефон <span class="text-danger">*</span></label>
                                    <div class="row">
                                        <div class="{$cart_data.tel ? 'col-8' : 'col-12'}">
                                            <input type="tel" class="form-control mx-0" bind:value={$cart_data.tel} on:change={handlerSaveCardData}>
                                        </div>
                                        {#if $cart_data.tel}
                                            <div class="col-2 text-center">
                                                <a class="btn btn-outline-light" target="_blank" href="tel:{$cart_data.tel}">
                                                    <i class="fas fa-phone-square-alt fa-2x text-dark"></i>
                                                </a>
                                            </div>
                                            <div class="col-2 text-center">
                                                <a class="btn btn-outline-light" target="_blank" href="https://api.whatsapp.com/send/?phone={$cart_data.tel}">
                                                    <i class="fab fa-whatsapp-square fa-2x text-success"></i>
                                                </a>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">E-Mail</label>
                                    <input type="email" class="form-control" bind:value={$cart_data.email} on:change={handlerSaveCardData}>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Адрес</label>
                                    <textarea class="form-control" rows="3" bind:value={$cart_data.address} on:change={handlerSaveCardData}></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Комментарий</label>
                                    <textarea class="form-control" rows="3" data-note="{$cart_data.note}" bind:value={$cart_data.comment} on:change={handlerSaveCardData}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        {#if $cart_data.nomDocStr}
                            <div class="col-6">
                                <button type="button" class="btn btn-primary btn-block" on:click={() => handlerSend(false)}>
                                    Сохранить #{$cart_data.nomDocStr ?? ''}
                                </button>
                            </div>
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary btn-block" on:click={() => handlerSend(true)}>
                                    Новый
                                </button>
                            </div>
                            <div class="col-12 mt-1">
                                <button type="button" class="btn btn-danger btn-block btn-sm" on:click={handlerClear}>
                                    Очистить
                                </button>
                            </div>
                        {:else}
                            <div class="col-12">
                                <button type="button" class="btn {is_error ? 'btn-danger' : 'btn-primary'} btn-block btn-lg" on:click={handlerSend} disabled={is_disabled}>
                                    {#if is_disabled}
                                        {#if is_error}
                                            Ошибка!
                                        {:else}
                                            Отправляем..
                                        {/if}
                                    {:else}
                                        Создать заказ
                                    {/if}
                                </button>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        {:else}
            <div class="offcanvas-body text-center">
                <div class="row">
                    <div class="col-sm-12 empty-cart-cls text-center">
                        <img src="/img/cart_empty.png" width="130" height="130" class="img-fluid mb-4 mr-3">
                        <h3><strong>Корзина пуста</strong></h3>
                        <h4>Для начала нужно что-то добавить..</h4>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>
<!-- * App OffCanvas -->

<div class="modal fade dialogbox" id="order-send" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-success">
                <i class="far fa-check-circle"></i>
            </div>

            {#if order_num}
                <div class="modal-header">
                    <h5 class="modal-title">Заказ отправлен</h5>
                </div>
                <p class="modal-body">Запишите номер вашего заказа: {order_num}</p>
            {:else}
                <div class="modal-header">
                    <h5 class="modal-title">Что-то пошло не так</h5>
                </div>
                <p class="modal-body">Ваш заказ не был отправлен</p>
            {/if}

            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>
